export default __webpack_public_path__ + "static/media/ic_gmx_40.065f5852.svg";